import { render, staticRenderFns } from "./TaskRelativeTime.vue?vue&type=template&id=63e30b8e&scoped=true&"
import script from "./TaskRelativeTime.vue?vue&type=script&lang=js&"
export * from "./TaskRelativeTime.vue?vue&type=script&lang=js&"
import style0 from "./TaskRelativeTime.vue?vue&type=style&index=0&id=63e30b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e30b8e",
  null
  
)

export default component.exports